import axios from "axios";

/**
 * Calling api directly, better to call from store
 */

const fetchCourses = (instanceId) => {
  return axios.post("campus-drive/moodles/courses/data-list", {
    instanceId,
  });
};

const fetchCollegeOfCourses = (courses, instanceId) => {
  return axios.post("campus-drive/moodles/course-college", {
    courses,
    instanceId,
  });
};

const fetchQuizzesByCourseId = (payload) => {
  return axios.post("campus-drive/moodles/course/quiz-list", payload);
};

// const fetchQuizConfigurations = (payload) => {
//   return axios.post("campus-drive/moodles/course/quiz/config", payload);
// };

const fetchCourseConfigurations = (payload) => {
  return axios.post("campus-drive/moodles/course/config", payload);
};

const updateCourseConfigurations = (payload) => {
  return axios.post("campus-drive/moodles/course/edit-config", payload);
};

const updateSlot = (payload) => {
  return axios.post("campus-drive/moodles/course/edit-slot", payload);
};

const updateQuizTimelimitByQuizId = (payload) => {
  return axios.post("campus-drive/moodles/course/quiz/edit-timelimit", payload);
};

const fetchCategories = (instanceId) => {
  return axios.post("campus-drive/moodles/course/category-list", {
    instanceId,
  });
};

const duplicateCourse = (payload) => {
  return axios.post("campus-drive/moodles/course/duplicate", payload);
};

const deleteUsersFromCourse = (payload) => {
  return axios.post("campus-drive/moodles/course/delete-users", payload);
};

const deleteCourse = (payload) => {
  return axios.post("campus-drive/moodles/course/delete", payload);
};

export default {
  fetchCourses,
  fetchCollegeOfCourses,
  fetchQuizzesByCourseId,
  // fetchQuizConfigurations,
  fetchCourseConfigurations,
  updateCourseConfigurations,
  updateSlot,
  updateQuizTimelimitByQuizId,
  fetchCategories,
  duplicateCourse,
  deleteUsersFromCourse,
  deleteCourse,
};
